module.exports = __webpack_public_path__ + "static/memphis-57858efe498edc21ad72eadb8ef6e8b8.png";